import React, { ReactNode, FC, useEffect, useState } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { useShoppingContext } from 'contexts/ShoppingContext';
import deliveryPassServiceClient from 'services/deliveryPass';
import { getFeatureFlags } from 'utils/featureFlags';
import { DELIVERY_PASS_NOT_AVAILABLE } from 'constants/delivery-pass-statuses';
import { DeliveryPassContext } from './DeliveryPassContext';

type DeliveryPassProviderProps = {
  children: ReactNode;
};

const DeliveryPassProvider: FC<DeliveryPassProviderProps> = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { shoppingContext } = useShoppingContext();
  const [status, setStatus] = useState<string>(DELIVERY_PASS_NOT_AVAILABLE);
  const { deliveryPass_enableDeliveryPass: enableDeliveryPass } = getFeatureFlags();
  const { state: authState } = useAuthentication();

  useEffect(() => {
    if (enableDeliveryPass && authState.isLoggedIn) {
      const fetchDeliveryPassStatus = async () => {
        const { status: deliveryPassStatus } =
          await deliveryPassServiceClient.getDeliveryPassStatus({
            authHeader: authState.token?.authHeader || 'Bearer unauthenticated',
            customerId: shoppingContext?.customerId,
          });
        if (deliveryPassStatus) {
          setStatus(deliveryPassStatus);
        }
      };

      fetchDeliveryPassStatus();
    }
  }, [
    authState.isLoggedIn,
    authState.token?.authHeader,
    enableDeliveryPass,
    shoppingContext?.customerId,
  ]);

  return <DeliveryPassContext.Provider value={status}>{children}</DeliveryPassContext.Provider>;
};

export default DeliveryPassProvider;
